import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Show first panel by default
    if (this.panelTargets.length > 0) {
      this.showDepartment(this.panelTargets[0].dataset.departmentId)
    }
  }

  select(event) {
    const departmentId = event.currentTarget.dataset.departmentId
    this.showDepartment(departmentId)
  }

  showDepartment(id) {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.departmentId !== id)
    })

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.departmentId === id
      tab.classList.toggle("border-blue-500", isActive)
      tab.classList.toggle("bg-blue-50", isActive)
      tab.classList.toggle("border-transparent", !isActive)
    })
  }
}
